export const getSteps = (current: number) => [
    { number: 1, title: 'Select Target', isActive: current === 1, isCompleted: current > 1 },
    { number: 2, title: 'Select Attributes', isActive: current === 2, isCompleted: current > 2 },
    { number: 3, title: 'Review', isActive: current === 3, isCompleted: current > 3 }
];


function getOrdinalSuffix(day: number) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
}


export const formatDateTime = () => {
    const date = new Date();
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${month} ${day}${getOrdinalSuffix(day)}, ${year} - ${hours}:${minutes} AM UTC`;
}
